import ProvidersDirectory from "@/components/ProvidersDirectory";
import { fetchMechanics } from "@/lib/api";

const SPECIALTIES = [
  "Engine", "Brakes", "Transmission", "Electrical", "Diagnostics",
  "Suspension", "Diesel", "Electric Vehicles", "Exhaust", "General Repair",
];

export default function MechanicsPage() {
  return (
    <ProvidersDirectory
      title="Local Mechanics"
      subtitle="Certified shops near you, ranked by proximity and reputation. Tap Call to dial directly or open Details for hours and full service list."
      fetcher={fetchMechanics}
      specialties={SPECIALTIES}
      testIdPrefix="mechanic"
    />
  );
}
